import { observable } from 'mobx';
import { Store } from 'bernie-plugin-mobx';

import { FetchOptions, SerializedData } from 'bernie-core';

import {
  FlightsQueryState,
  FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoaded
} from '__generated__/api/types';

export class FlightsMerchandisingConfirmationCriteriaStore extends Store {
  @observable
  public merchandisingConfirmationCriteria: FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoaded.Variables;
  @observable public tripId: string;
  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setCriteriaFromUrl(fetchOptions: FetchOptions) {
    const { query } = fetchOptions;
    this.merchandisingConfirmationCriteria.tripId = query?.tripId;
  }
}

FlightsMerchandisingConfirmationCriteriaStore.DEFAULTS = {
  merchandisingConfirmationCriteria: {
    queryState: FlightsQueryState.LOADING,
    tripId: 'tripId'
  }
};
